import script from "./SuccessToast.vue?vue&type=script&setup=true&lang=ts"
export * from "./SuccessToast.vue?vue&type=script&setup=true&lang=ts"

import "./SuccessToast.vue?vue&type=style&index=0&id=0c9ea822&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0c9ea822"]])

export default __exports__